// extracted by mini-css-extract-plugin
export default {"educationInputGroup":"form_educationInputGroup__jqYj8"};